import { QueryModifierContext } from "./context";
import React from "react";

export const useQueryModifier = ({ defaultSort = [] } = {}) => {
  const [sort, setSort] = React.useState(defaultSort);

  const setSortFn = (by, direction) => {
    setSort([by, direction]);
  };

  return {
    sort,
    setSort: setSortFn,
  };
};

export const useQueryModifierProvider = ({ errorOnNotFound = true } = {}) => {
  const context = React.useContext(QueryModifierContext);
  if (context === undefined && errorOnNotFound) {
    throw new Error("no QueryModifierProvider found");
  }
  return context;
};
